import type { AppointmentStatus } from "@/types/appointments/api-types/appointment-types";

export const CLIENT_HISTORY_STATUSES: AppointmentStatus[] = [
  "completed",
  "cancelled",
  "no_show",
];

export const CLIENT_UPCOMING_STATUSES: AppointmentStatus[] = [
  "booked",
  "confirmed",
  "arrived",
  "left_message",
];

export const CLIENT_HISTORY_PAGE_SIZE = 50;
export const CLIENT_UPCOMING_PAGE_SIZE = 50;

/** A visit's history-note fields and their labels (client history tab, copilot client card). */
export const HISTORY_NOTE_FIELDS = [
  { name: "colour_notes", label: "Colour Notes" },
  { name: "cut_notes", label: "Cut Notes" },
  { name: "product_notes", label: "Product Notes" },
  { name: "conversation_notes", label: "Conversation Notes" },
] as const;
